import MeeyImage from "@/components/MeeyImage";
import PopupAvatarUser from "@/components/PopupAvatarUser";
import NotiMobile from "@/components/PopupNotification/NotiMobile";
import { STATIC_DOMAIN } from "@/constants/environment";
import { useAuth } from "@/hooks/useAuth";
import Link from "next/link";

const HeaderDetail = () => {
  const { user, login } = useAuth();
  return (
    <div className="bg-white flex items-center justify-between h-14 w-full sticky top-0 z-30 shadow-light-2 px-2">
      <Link href={"/"} title="home">
        <MeeyImage
          src={STATIC_DOMAIN + "/logo_blue.svg"}
          alt="home"
          resizeOnFly={false}
          resizeOptions={{
            width: 131,
            height: 42,
          }}
        />
      </Link>
      <div className="flex gap-4">
        {/* <div className="flex items-center gap-1 bg-grey-100 h-10 rounded-full py-2 px-3">
          <i className="mrv mrv-search text-fs-20 text-grey-500"></i>
        </div> */}
        {/* <div className="h-10 w-10 bg-black-100 flex items-center justify-center rounded-full">
          <i className="mrv mrv-notifications"></i>
        </div> */}
        <div className="flex items-center gap-5">
          {!user ? (
            <div
              className="flex items-center gap-1 bg-grey-100 h-10 rounded-full py-2 px-3"
              onClick={login}>
              <i className="mrv mrv-account_circle text-fs-20 text-grey-500"></i>
            </div>
          ) : null}
          <NotiMobile />

          <PopupAvatarUser />
        </div>
      </div>
    </div>
  );
};

export default HeaderDetail;
